import { auth } from './auth'
import PersistentWebSocket from './persistentWebSocket'
import { writable } from 'svelte/store'
import { baseUrl, protocol } from './const'
import getErrorFromResponse from './utils/getErrorFromResponse'

const endpoints = [
	{ name: 'flights', singular: 'flight'},
	{ name: 'devices', singular: 'device' },
	{ name: 'links', singular: 'link' },
	{ name: 'overlays', singular: 'overlay' },
]

let authGuestToken = ""

export function setGuestToken(guestToken) {
	authGuestToken = guestToken
}

export async function guestFlight(id) {
	const data = await doFetch(`guest/flight/${id}`)
	for (const key of Object.keys(data)) {
		fillCache(key, data[key])
	}
}

async function getAuthorizationHeader() {
	let token = 'guest-' + authGuestToken
	if (!authGuestToken?.length) {
		token = await auth.getToken()
	}
	return 'Bearer ' + token
}

export async function doRawFetch(endpoint) {
	const headers = {}
	headers['Authorization'] = await getAuthorizationHeader()

	const response = await fetch(`${protocol}//${baseUrl}/${endpoint}`, {
		headers
	})
	if (!response.ok) {
		throw new Error(`Error: ${endpoint} - ${await getErrorFromResponse(response)}`)
	}
	return response
}

export async function doFetch(endpoint, method = 'GET', body = null, ct = null) {
	const headers = {
		'Connection': 'close',
	}
	headers['Authorization'] = await getAuthorizationHeader()
	if (!ct) {
		headers['Content-Type'] = 'application/json'
	}
	const response = await fetch(`${protocol}//${baseUrl}/${endpoint}`, {
		headers,
		method,
		body: ct ? ct : (body ? JSON.stringify(body) : undefined), 
	})
	if (!response.ok) {
		throw new Error(`Error: ${method} - ${endpoint} - ${await getErrorFromResponse(response)}`)
	}
	if (response.status === 204) return
	return await response.json()
}


export const api = {}
window.api = api

const cache = {}
window.cache = cache

export function setupCache(guestToken) {
	if (guestToken && guestToken.length > 0) {
		setGuestToken(guestToken)
	}
	for (const endpoint of endpoints) {
		const { subscribe, set } = writable([])

		cache[endpoint.name] = {
			isLoaded: false,
			promise: {},
			items: {},
			setter: set,
		}
		if (endpoint.singular) {
			cache[endpoint.singular] = cache[endpoint.name]
		}
		api[endpoint.name] = {
			get: endpointGet(endpoint.name),
			create: body => doFetch(endpoint.name, 'POST', body),
			update: (id, body) => doFetch(endpoint.name + '/' + id, 'PATCH', body),
			delete: (id) => doFetch(endpoint.name + '/' + id, 'DELETE'),
			store: { subscribe }
		}
	}
}

export function fillCache(id, entries) {
	cache[id].items = entries
	cache[id].isLoaded = true
}

export default api

// async function preCache() {
//  await Promise.all(endpoints.map(async endpoint => {
//      if (!cache[endpoint].isLoaded) {
//          try {
//              await loadItems(endpoint)
//          } catch (error) {
//              // ignore initial load error
//          }
//      }
//  }))
// }

async function loadItems(endpoint) {
	const entities = await doFetch(endpoint)
	for (const e of entities) {
		cache[endpoint].items[e.id] = e
	}
	cache[endpoint].setter(cache[endpoint].items)
	cache[endpoint].isLoaded = true
}

function endpointGet(endpoint) {
	return async id => {
		const ci = cache[endpoint]
		if (!authGuestToken || authGuestToken.length == 0) await auth.getToken()
		if (id) {
			let item = ci.items[id]
			if (!item) {
				if (ci.promise[id]) return await ci.promise[id]
				ci.promise[id] = doFetch(endpoint + '/' + id)
				item = await ci.promise[id]
				delete ci.promise[id]
				if (item) ci.items[item.id] = item
				ci.setter(ci.items)
			}
			return item
		} else {
			if (!ci.isLoaded) {
				if (!ci.promise['all']) {
					ci.promise['all'] = loadItems(endpoint)
				}
				try {
					await ci.promise['all']                     
				} finally {
					delete ci.promise['all']
				}
			}
			return ci.items
		}
	}
}

function handleCachedData(data) {
	const entity = data[data.entityType]
	switch (data.action) {
		case 'LOCATION':
		case 'UPDATE':
		case 'CREATE':
			if (data.info) {
				entity.info = data.info
			}
			cache[data.entityType].items[entity.id] = entity
			cache[data.entityType].setter(cache[data.entityType].items)
			break
		case 'DELETE':
			delete cache[data.entityType].items[entity.id]
			cache[data.entityType].setter(cache[data.entityType].items)
			break
	}
}

let ws
export function setupFeed() {
	if (ws) {
		console.warn("Check if feed WS needs to close")
		return
	}

	const adminFeedUrl = (protocol === "https:" ? "wss://" : "ws://") + baseUrl + "/feed"
	ws = new PersistentWebSocket(async () => adminFeedUrl + "?token=" + await auth.getToken())
	ws.connect()
	ws.addEventListener('message', msg => {
		const data = JSON.parse(msg.detail)
		if (cache[data.entityType]) {
			handleCachedData(data)
		} else {
			console.error("Unhandled data type", data)
		}
        
	})
}
